module.exports = __webpack_public_path__ + "img/consultation.07e7504e.png";